//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { AddToCartIcon, AddToCartGrayIcon } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { addItem, withReferral } from '@helpers/referrals';
import { handleGtmEvent } from '@helpers/gtm';
import { responseFormatter, shopifyFormatter } from '@helpers/formatter';
import { withTranslation } from 'react-i18next';
import { StoreConfigContext } from '@helpers/storeConfigContext';
// Local Storage
import { getValue } from '@helpers/localStorage';
import { IsAdminApproved } from '@helpers/constants/localStorage';

// Strategy to ensure linearity in the add to cart actions in order to prevent concurrency errors
let addToCartWorkQueue = Promise.resolve();

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class AddItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: null,
    };
    this.isAdded = this.isAdded.bind(this);
    this.errorDisplayAndReset = this.errorDisplayAndReset.bind(this);
  }

  isAdded() {
    const { __referral, product } = this.props;
    return (
      __referral &&
      __referral.items &&
      __referral.items.findIndex(
        (x) => x.shopifyProductId.toString() === product.id.toString()
      ) > -1
    );
  }

  errorDisplayAndReset(errMessage, errorParentCb, errorResetParentCb) {
    const formattedError = responseFormatter.error(errMessage).message();
    if (errorParentCb) errorParentCb(formattedError);
    this.setState({ errorMessage: formattedError });
    setTimeout(() => {
      this.setState({ errorMessage: null });
      errorResetParentCb();
    }, 3000);
  }

  render() {
    let that = this;
    const { loading, errorMessage } = this.state;
    const {
      product,
      className,
      didAddItem,
      errorCb: errorParentCb,
      errorResetCb: errorResetParentCb,
      index,
    } = this.props;
    const added = this.isAdded();

    const componentClasses = classNames(styles.AddItem, {
      [className]: className,
      [styles.Added]: added,
    });

    const isAdminApproved = getValue(IsAdminApproved, true);
    const defaultVariant = shopifyFormatter.product(product).defaultVariant();
    const isAvailable =
      shopifyFormatter.variant(defaultVariant).isAvailable() && isAdminApproved;

    return (
      <div
        className={componentClasses}
        {...(!isAdminApproved
          ? { title: this.props.t('dashboard_PendingApprovalAddTooltip') }
          : {})}
      >
        {/* to-do: use a vector for the plus sign */}
        <Button
          style={ButtonStyle.Link}
          className={styles.Button}
          loading={loading}
          disabled={added || !isAvailable || errorMessage}
          iconComponent={
            added || errorMessage ? <AddToCartGrayIcon /> : <AddToCartIcon />
          }
          onClick={() => {
            this.setState({ loading: true });

            addToCartWorkQueue = addToCartWorkQueue.then(() => {
              return addItem(product)
                .then((result) => {
                  const itemSuccessfullyAdded = (result.items || []).some(
                    (item) => item.shopifyProductId === `${product.id}`
                  );
                  if (itemSuccessfullyAdded) {
                    if (didAddItem) {
                      didAddItem(product);
                    }

                    product.changedQuantity = 1;
                    handleGtmEvent('add_to_cart', {
                      products: [product],
                      context: this.context,
                      metadata: { index },
                    });
                  } else {
                    this.errorDisplayAndReset(
                      null,
                      errorParentCb,
                      errorResetParentCb
                    );
                  }
                })
                .catch((err) => {
                  this.errorDisplayAndReset(
                    err,
                    errorParentCb,
                    errorResetParentCb
                  );
                })
                .finally(() => that.setState({ loading: false }));
            });
          }}
        >
          {/* {isAvailable
            ? added
              ? t('dashboard_Added')
              : `${t('dashboard_AddToList')}`
            : t('dashboard_SoldOut')} */}
        </Button>
        {!errorParentCb && errorMessage && (
          <span className={classNames(styles.ErrorMessage)}>
            {errorMessage}
          </span>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withReferral(withTranslation()(AddItem));

AddItem.contextType = StoreConfigContext;
